import Controller, { OnBeforeSubmit, OnBlur, OnCancel, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FormAPI, InputAPI, ModalService, ToastService } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { Inject } from '@odinjs/odin';
import moment from 'moment';

import { WoundsEndTreatmentAliases as Alias, FragmentNames } from '../../../../codegen';
import BaseController from '../../../../controllers/BaseController';
import { Endpoint } from '../../../../constants/endpoints';
import timeService from '../../../../services/time-service';
import { ISO_FULL_DATE_FORMAT } from '../../../../constants/date-utils';
import { DomainType } from '../../types/wounds-dressings-types';

@Controller({ fragment: FragmentNames.WOUNDS_END_TREATMENT })
export default class WoundsEndTreatmentController extends BaseController {

  @Inject(Alias.FORM_WOUNDS_END_TREATMENT)
  private formAPI!: FormAPI;

  @Inject(Alias.INPUT_RELEASE_DATE)
  private inputAPI!: InputAPI;

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'wounds-end-treatment',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }
  private endTreatmentWound(): void {
    const { woundId } = this.historyService.getCurrentRouteParams();
    const formData = this.formAPI.getRecord();

    const body = {
      reasonEnd: (formData.reasonEndTreatment as DomainType)?.valueDomain,
      releaseDate: moment(String(formData.releaseDate)).utc().format(ISO_FULL_DATE_FORMAT),
      woundId,
    } as Record<string, Value>;

    this.formAPI.setLoading(true);
    HttpService.put(Endpoint.END_TREATMENT_WOUND, undefined, {body})
      .then(() => {
        applicationContext.popNavigationItem();
        applicationContext.popNavigationItem();
        this.showToast('tws.end-treatment', ToastLevel.SUCCESS);
      }).catch((err) => {
        err?.body && this.showToast(err?.body, ToastLevel.ERROR);
      }).finally(() => this.formAPI.setLoading(false));
  }

  @OnMount(Alias.FORM_WOUNDS_END_TREATMENT)
  handleMount(): void {
    timeService.getCurrentDateTime()
      .then(date => this.inputAPI.setValue(date))
      .catch(() => this.inputAPI.setValue(moment().format(ISO_FULL_DATE_FORMAT)));
  }

  @OnBlur(Alias.INPUT_RELEASE_DATE)
  handleBlurDate(): void {
    const inputDate = this.inputAPI.getValue() as string;
    const requiredLength = 19;
    if (inputDate.length < requiredLength) {
      this.showToast('text.report-date-and-hour', ToastLevel.WARNING);
    }
  }

  @OnCancel(Alias.FORM_WOUNDS_END_TREATMENT)
  handleCancelForm(): void {
    ModalService.close(FragmentNames.WOUNDS_END_TREATMENT);
  }

  @OnBeforeSubmit(Alias.FORM_WOUNDS_END_TREATMENT)
  handleSubmitForm(): void {
    this.endTreatmentWound();
  }

}